
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import { getModelList, pilesAddBatch } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class PiModelAdd extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private devTypeList!: object[];
  private modalShow = false;
  private loading = true;

  private deviceParams: object[] = [
    {
      deviceModelPkId: "",
      deviceType: "",
      quantity: "",
      remark: "",
      snEndNo: "",
      snStartNo: ""
    }
  ];
  private FormData: objAny = {};
  private modalTitle = i18n.t("equipmentList.add");

  private ruleInline: objAny = {
    deviceType: [
      {
        required: true,
        message: i18n.t("pleaseSelect"),
        trigger: "change"
      }
    ],
    deviceModelPkId: [
      {
        required: true,
        message: i18n.t("pleaseSelect"),
        trigger: "change"
      }
    ],
    // quantity:[],
    snStartNo: [
      {
        required: true,
        message: i18n.t("startSNPl"),
        trigger: "blur"
      },
      {
        validator: regular.int,
        trigger: "blur"
      },
      {
        type: "string",
        min: 12,
        message: i18n.t("must12Digits"),
        trigger: "blur"
      }
    ],
    snEndNo: [
      {
        required: true,
        message: i18n.t("pleaseSelect"),
        trigger: "blur"
      },
      {
        validator: regular.int,
        trigger: "blur"
      },
      {
        type: "string",
        min: 12,
        message: i18n.t("must12Digits"),
        trigger: "blur"
      }
    ]
  };
  private formItem: objAny = {
    deviceParams: []
  };
  private paramList: objAny = {
    deviceModelPkId: "",
    deviceType: "",
    quantity: "",
    remark: "",
    snEndNo: "",
    snStartNo: ""
  };

  private modelList: object[] = [];
  private oprList = [];
  private deviceTypeList = [];
  private matchEquipmentList = [];
  private stationList = [];
  private numberQuantity = 0;

  public open() {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }
    this.modalShow = true;

    this.formItem.deviceParams = [];
    this.addFormData();
  }

  public addFormData() {
    let json;
    // if (this.formItem.deviceParams.length > 0) {
    //   json = this.formItem.deviceParams[this.formItem.deviceParams.length - 1];
    // } else {
    json = JSON.parse(JSON.stringify(this.paramList));
    // }
    json = JSON.parse(JSON.stringify(json));
    this.formItem.deviceParams.push(json);
  }
  // public uploaOutlineData() {
  // }
  public loseFocus(unit: objAny) {
    if (unit.snEndNo && unit.snStartNo && unit.snEndNo >= unit.snStartNo) {
      this.numberQuantity = parseInt(unit.snEndNo) - parseInt(unit.snStartNo);
      unit.quantity = this.numberQuantity + 1;
    } else {
      unit.quantity = "";
    }
  }

  delFormData(index: number) {
    this.formItem.deviceParams.splice(index, 1);
  }

  public handleSubmit(): void {
    this.loading = true;

    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async getModelList(param: objAny): Promise<void> {
    if (param) {
      const ret = await getModelList({ deviceType: param });
      if (ret.status === this.$config.apiStatus) {
        this.modelList = ret.data;
      }
    }
  }

  async submitData(): Promise<void> {
    this.formItem.deviceParams.map((item: objAny) => {
      item.quantity = parseInt(item.quantity);
    });
    const ret = await pilesAddBatch(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success("操作成功");
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
